import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('BrandResource', BrandResource);

    /* @ngInject */
    function BrandResource() {
        BrandResource.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function BrandResource(brandResourceData) {
            if (!brandResourceData) {
                this.buildEmpty();
            } else {
                this.build(brandResourceData);
            }
        }

        return BrandResource;

        /////////////////////

        function buildEmpty() {
            this.fileHeaderId = null;
            this.type = null;
        }

        function build(brandResourceData) {
            this.fileHeaderId = brandResourceData.fileHeaderId || null;
            this.type = brandResourceData.type || null;
        }
    }
})();
